<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header class="border-0">
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <h3 class="mb-0">Listado de notificaciones</h3>
              </div>
              <div class="col-lg-6 col-md-6 d-flex justify-content-end">
                <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @change="reloadPaginate(1)">
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
                <input type="text" class="form-control" placeholder="Filtrar por destino, titulo o mensaje" v-model="pagination.search" @keyup="manualSearch">
              </div>
            </div>
          </b-card-header>

          <b-card-body>
            <div class="table-responsive">
              <table class="table table-bordered table-striped table-sm">
                <thead>
                <tr>
                  <th class="text-uppercase  font-weight-bolder opacity-7">DESTINO</th>
                  <th class="text-uppercase  font-weight-bolder opacity-7">TITULO</th>
                  <th class="text-uppercase  font-weight-bolder opacity-7">MENSAJE</th>
                  <th class="text-uppercase  font-weight-bolder opacity-7">ICONO</th>
                  <th class="text-uppercase  font-weight-bolder opacity-7">OPCIONES</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, key) in arrayNotifications" :key="key">
                  <td>
                    <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.type}}</span>
                  </td>
                  <td>
                    <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.title}}</span>
                  </td>
                  <td>
                    <div class="limited-width_30">
                      <span class="text-uppercase text-xs font-weight-bold mb-0">{{item.message}}</span>
                    </div>
                  </td>
                  <td>
                      <span class="text-xs font-weight-bold text-white badge rounded-pill" :class="item.icon=== 'error'? 'bg-danger': 'bg-' + item.icon">
                        {{item.icon}}
                      </span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary" title="Asignar al usuario" @click="assign(item, item.bank)">
                      <i class="ni ni-check-bold"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-primary"  title="Ver preview" @click="preview(item._id,'active')">
                      <i class="ni ni-zoom-split-in"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>

          <b-card-footer class="py-4 d-flex justify-content-between">
            <p class="text-xs font-weight-bold mb-0">total registros: {{pagination.totalRows}}</p>
            <base-pagination @change="reloadPaginate" v-model="pagination.page" :per-page="Number(pagination.limit)" :total="pagination.totalRows"></base-pagination>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "Notifications",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    arrayNotifications: [
      {
        bank: '',
        title: '',
        message: '',
        icon: '',
        status: '',
        created_at: ''
      },
    ],
    tableDataUser: [],
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    getData() {
      this.arrayNotifications = []
      get(`notifications/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`, null, true).then(({data}) => {
        this.arrayNotifications = data.docs
        this.pagination.totalRows = data.count
        this.pagination.page = data.page
        this.pagination.pages = data.pages
      })
    },
    assign(notification, bank) {
      post("notifications/assign", {
        notificationsId: notification._id,
        type: notification.type,
        clientId: this.$route.params.id,
        bank: bank
      }, true).then(() => {
        this.getData()
        this.showMessage("Notificacion asignada correctamente")
      })
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    preview(id, type = 'client') {
      let model = null
      if (type == 'active')
        model = this.arrayNotifications.find(x => x._id == id)
      else
        model = this.tableDataUser.find(x => x._id == id).notificationsId
      this.$swal({
        title: model.title,
        html: model.message,
        icon: model.icon,
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      })
    },
    makeDefaul(row){
      post(`notifications/make-default`, {_id: row._id, type: row.type}, true)
        .then(() => this.getData())
    },
  }
}
</script>

<style scoped>

</style>
